import { Alert, Tab, Text } from "@jarvis-catalyst/ui-components";
import React from "react";
import IdentityDocumentTab from "../ValidateUserTabs/IdentityDocumentTab";
import { FormType, ProfileUsers } from "../../types";
import EmailsTab from "../ValidateUserTabs/EmailsTab";
import PhonesTab from "../ValidateUserTabs/PhonesTab";
import UsersTab from "../ValidateUserTabs/UsersTab";
import ErrorComponent from "../Error";
import DevicesTab from "../ValidateUserTabs/DevicesTab";
import { FormAlertGroup } from "../../styled-components/FormGroup";

type Props = {
  data?: ProfileUsers;
  form?: FormType;
};

const ProfileForm = ({ data, form }: Props): JSX.Element => {
  return (
    <div>
      {!data?.profile?.coreUserId && (
        <div className="row">
          <FormAlertGroup className="text-center">
            <Alert color="danger">
              <strong>IMPORTANT:</strong> User not found in Core Users
            </Alert>
          </FormAlertGroup>
        </div>
      )}

      <div className="row">
        <div className="col">
          <Text className="">CIAM ID</Text>
          <input type="text" className="form-control" disabled value={data?.profile?.ciamId ?? ""} />
        </div>
        <div className="col">
          <Text className="">CORE USER ID</Text>
          <input type="text" className="form-control" disabled value={data?.profile?.coreUserId ?? ""} />
        </div>
      </div>

      <div className="row">
        <div className="col">
          <Text className="">First Name</Text>
          <input type="text" className="form-control" disabled value={data?.profile?.firstName ?? ""} />
        </div>

        <div className="col">
          <Text className="">Paternal Surname</Text>
          <input type="text" className="form-control" disabled value={data?.profile?.paternalSurname ?? ""} />
        </div>
      </div>

      <div style={{ marginTop: "25px" }}>
        <Tab
          pages={[
            {
              title: "Users",
              key: `users`,
              body: <UsersTab users={data?.users} />
            },
            {
              title: "Identity Document",
              key: `identity-document`,
              body: data?.profile?.identityDocument?.length ? (
                <IdentityDocumentTab identityDocuments={data?.profile.identityDocument} />
              ) : (
                <ErrorComponent isError={404} title="No data found" text="" />
              )
            },
            {
              title: "Emails",
              key: `emails`,
              body: data?.profile?.emails?.length ? (
                <EmailsTab emails={data?.profile.emails} />
              ) : (
                <ErrorComponent isError={404} title="No data found" text="" />
              )
            },
            {
              title: "Phones",
              key: `phones`,
              body: data?.profile?.phones?.length ? (
                <PhonesTab phones={data?.profile.phones} />
              ) : (
                <ErrorComponent isError={404} title="No data found" text="" />
              )
            },
            {
              title: "Devices",
              key: `devices`,
              body: (
                <DevicesTab
                  ciamId={data?.profile.ciamId ?? ""}
                  username={data?.users?.[0]?.userName ?? ""}
                  form={form}
                />
              )
            }
          ]}
        />
      </div>
    </div>
  );
};

export default ProfileForm;
